
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'app-side-bar' })
export default class AppSideBar extends Vue {
  items: object[] = [
    { title: 'Todos os Serviços', icon: 'home', to: '/' },
    { title: 'Transportes', icon: 'directions_bus', to: '/transportes' },
    { title: 'VaiVem', icon: 'fa-id-card', to: '/vaivem' },
    { title: 'Ouvidoria', icon: 'phone_in_talk', to: '/ouvidoria' },
    { title: 'Processos', icon: 'file_copy', to: '/processos' },
    { title: 'Carteira Macrorregião', icon: 'account_box', to: '/carteira-macrorregiao' },
    { title: 'Saneamento', icon: 'water_drop', to: '/saneamento/login' },
    // { title: "Financeiro", icon: "paid", to: "/financeiro" }
    { title: 'Gás Canalizado', icon: 'propane_tank', to: '/gas-canalizado' },
    { title: 'Cadastro Positivo de Veículos', icon: 'directions_car', to: '/cpv' }
  ];
}
